const config = {
    projectId: "dreico-corvus",
    communityName: "Corvus",
    productionUrl: "https://corvus.dreico.net",
    algoliaIndex: "corvus_user",
}

export default config
